import type { RouteRecordRaw } from 'vue-router';

import { DEV_FEATURE } from '~/constants';

import { makeKeyBuilder, makeOrganisationRoute } from '~/features/useRouteMeta';

import OrganisationPortCallsDetailsCargo from '~/pages/OrganisationPortCallsDetailsCargo.vue';
import OrganisationPortCallsDetailsContacts from '~/pages/OrganisationPortCallsDetailsContacts.vue';
import OrganisationPortCallsDetailsDocuments from '~/pages/OrganisationPortCallsDetailsDocuments.vue';
import OrganisationPortCallsDetailsIndex from '~/pages/OrganisationPortCallsDetailsIndex.vue';
import OrganisationPortCallsDetailsOverview from '~/pages/OrganisationPortCallsDetailsOverview.vue';
import OrganisationPortCallsDetailsRotation from '~/pages/OrganisationPortCallsDetailsRotation.vue';
import OrganisationPortCallsIndex from '~/pages/OrganisationPortCallsIndex.vue';

export const organisationPortCallsRoutes: Readonly<RouteRecordRaw[]> = [
  makeOrganisationRoute({
    name: 'OrganisationPortCallsIndex',
    path: '/port-calls',
    component: OrganisationPortCallsIndex,
    devFeature: DEV_FEATURE.PORT_CALLS,
  }),
  makeOrganisationRoute({
    path: '/port-calls/details/voyage/:voyageId/port/:portId',
    component: OrganisationPortCallsDetailsIndex,
    devFeature: DEV_FEATURE.PORT_CALLS,
    keyBuilder: makeKeyBuilder('OrganisationPortCallsDetailsIndex'),
    props: (route) => ({
      voyageId: route.params.voyageId as string,
      portId: route.params.portId as string,
    }),
    children: [
      {
        name: 'OrganisationPortCallsDetailsIndex',
        path: '',
        redirect: { name: 'OrganisationPortCallsDetailsOverview' },
      },
      {
        name: 'OrganisationPortCallsDetailsOverview',
        path: 'overview',
        component: OrganisationPortCallsDetailsOverview,
        props: true,
      },
      {
        name: 'OrganisationPortCallsDetailsCargo',
        path: 'cargo',
        component: OrganisationPortCallsDetailsCargo,
        props: true,
      },
      {
        name: 'OrganisationPortCallsDetailsRotation',
        path: 'rotation',
        component: OrganisationPortCallsDetailsRotation,
        props: true,
      },
      {
        name: 'OrganisationPortCallsDetailsDocuments',
        path: 'documents',
        component: OrganisationPortCallsDetailsDocuments,
        props: true,
      },
      {
        name: 'OrganisationPortCallsDetailsContacts',
        path: 'contacts',
        component: OrganisationPortCallsDetailsContacts,
        props: true,
      },
    ],
  }),
];
